import { render, staticRenderFns } from "./AjaxText.vue?vue&type=template&id=6fe2b492&"
import script from "./AjaxText.vue?vue&type=script&lang=js&"
export * from "./AjaxText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports